// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GameView_wrapper__2JFBH","wrapper__vert":"GameView_wrapper__vert__3uVct","AgameImageView":"GameView_AgameImageView__2_h5y"};